/**
 * atonce/outcome-grid — ruch 1:1 z kodem makiety online (bundle 08.10.2026, komponent kart z „falą”):
 * - strzałka: postęp E = (vh − górna krawędź rzędu H2|strzałka) / (wysokość rzędu + vh), okno liniowe [0,3; 0,62] → clip-path inset(0 (1−C)·100 % 0 0);
 * - karty: gdy lista jest widoczna w ≥ 25 % (IntersectionObserver threshold .25) rusza oś czasu t (rAF) o długości a_(n) = tb(n) + (n−1)·1280 + 1540 ms,
 *   tb(n) = 160 + (n−1)·140 + 520; karta i: translateY(calc(s·100 % + s·24 px)), s = 1 − easeOutCubic((t − (160 + 140·i)) / 520); po wyjściu listy t = 0;
 * - fala: po wjeździe kart czarny pasek z białym tytułem przechodzi po tytule karty i: start m = tb(n) + 1280·i, rysowanie 520 ms (--ease-in-out),
 *   postój 760 ms, zejście 260 ms (--ease-out); clip-path inset(−4px calc(100 % − R) −4px L), R/L w px względem najdłuższej linii (+4 px marginesu);
 *   linie paska = linie H3 zmierzone znak po znaku (Range), jak w makiecie. Przy „ogranicz ruch”: wszystko widoczne, bez fali.
 */
( function () {
	const roots = [ ...document.querySelectorAll( '.og[data-outcome="on"]' ) ];
	if ( ! roots.length ) {
		return;
	}
	const reduce = window.matchMedia( '(prefers-reduced-motion: reduce)' );
	const clamp01 = ( t ) => Math.min( 1, Math.max( 0, t ) );
	const bezier = ( [ x1, y1, x2, y2 ] ) => {
		const cx = 3 * x1, bx = 3 * ( x2 - x1 ) - cx, ax = 1 - cx - bx;
		const cy = 3 * y1, by = 3 * ( y2 - y1 ) - cy, ay = 1 - cy - by;
		const sx = ( t ) => ( ( ax * t + bx ) * t + cx ) * t;
		const sy = ( t ) => ( ( ay * t + by ) * t + cy ) * t;
		const dx = ( t ) => ( 3 * ax * t + 2 * bx ) * t + cx;
		return ( x ) => {
			if ( x <= 0 ) return 0;
			if ( x >= 1 ) return 1;
			let t = x;
			for ( let i = 0; i < 8; i++ ) {
				const e = sx( t ) - x;
				if ( Math.abs( e ) < 1e-6 ) return sy( t );
				const d = dx( t );
				if ( Math.abs( d ) < 1e-6 ) break;
				t -= e / d;
			}
			let lo = 0, hi = 1;
			t = x;
			for ( let i = 0; i < 40; i++ ) {
				const v = sx( t );
				if ( Math.abs( v - x ) < 1e-6 ) break;
				if ( v < x ) lo = t; else hi = t;
				t = ( lo + hi ) / 2;
			}
			return sy( t );
		};
	};
	const easeOut = bezier( [ 0.23, 1, 0.32, 1 ] ); // --ease-out (zejście fali)
	const easeInOut = bezier( [ 0.77, 0, 0.175, 1 ] ); // --ease-in-out (rysowanie fali)
	const cubicOut = ( r ) => 1 - Math.pow( 1 - clamp01( r ), 3 ); // karty (QR)
	const Q2 = 160, AB = 140, EB = 520; // start, odstęp, czas karty
	const GD = 520, KW = 760, IB = 260, E_ = GD + KW; // fala: rysowanie, postój, zejście
	const tb = ( n ) => Q2 + ( n - 1 ) * AB + EB;
	const total = ( n ) => tb( n ) + ( n - 1 ) * E_ + GD + KW + IB;

	// Linie tekstu H3 (znak po znaku) — jak i_() w makiecie.
	const splitLines = ( el ) => {
		const range = document.createRange();
		const lines = [];
		let cur = '', top = null;
		const walker = document.createTreeWalker( el, NodeFilter.SHOW_TEXT );
		for ( let node = walker.nextNode(); node; node = walker.nextNode() ) {
			const txt = node.textContent || '';
			for ( let k = 0; k < txt.length; k++ ) {
				range.setStart( node, k );
				range.setEnd( node, k + 1 );
				const r = range.getClientRects()[ 0 ];
				if ( r && r.width > 0 ) {
					if ( top === null ) top = r.top;
					else if ( r.top > top + 1 ) { lines.push( cur ); cur = ''; top = r.top; }
				}
				cur += txt[ k ];
			}
		}
		lines.push( cur );
		return lines.map( ( l ) => l.trim().replace( /­$/, '-' ) );
	};

	roots.forEach( ( root ) => {
		const row = root.querySelector( '.og__row' );
		const arrow = root.querySelector( '.og__arrow' );
		const list = root.querySelector( '.og__list' );
		if ( ! list ) return;
		const items = [ ...list.querySelectorAll( '.og__item' ) ];
		const n = items.length;
		const DUR = total( n );
		const cards = items.map( ( li, i ) => ( {
			i,
			inner: li.querySelector( '.og__card-in' ),
			h3: li.querySelector( '.og__card-title' ),
			band: li.querySelector( '.og__band' ),
			clip: li.querySelector( '.og__band-clip' ),
			text: li.querySelector( '.og__band-in' ),
			width: null,
			lines: null,
		} ) );
		let live = false, raf = 0, t0 = 0, progress = 0;

		// Pasek fali: te same linie co H3, szerokość najdłuższej linii (do px w clip-path).
		const prepareBands = () => {
			cards.forEach( ( c ) => {
				if ( ! c.h3 || ! c.text || ! c.clip || ! c.band ) return;
				const lines = splitLines( c.h3 );
				if ( JSON.stringify( lines ) !== JSON.stringify( c.lines ) ) {
					c.lines = lines;
					c.text.textContent = '';
					lines.forEach( ( l, k ) => {
						if ( k ) c.text.appendChild( document.createElement( 'br' ) );
						c.text.appendChild( document.createTextNode( l ) );
					} );
				}
				const wasHidden = c.band.hidden;
				c.band.hidden = false;
				const left = c.clip.getBoundingClientRect().left;
				c.width = Math.max( ...Array.from( c.text.getClientRects(), ( r ) => r.right - left ) );
				c.band.hidden = wasHidden;
			} );
		};
		const z = ( c, f ) => ( c.width === null ? ( f * 100 ).toFixed( 3 ) + '%' : ( f * ( c.width + 4 ) - 4 ).toFixed( 2 ) + 'px' );
		const paintArrow = () => {
			if ( ! arrow || ! row ) return;
			const r = row.getBoundingClientRect();
			const vh = window.innerHeight;
			const E = clamp01( ( vh - r.top ) / ( r.height + vh ) );
			const C = clamp01( ( E - 0.3 ) / 0.32 );
			arrow.style.setProperty( '--og-arrow', ( ( 1 - C ) * 100 ).toFixed( 3 ) + '%' );
		};
		const paintCards = () => {
			const t = progress * DUR;
			cards.forEach( ( c ) => {
				if ( c.inner ) {
					const s = 1 - cubicOut( ( t - ( Q2 + c.i * AB ) ) / EB );
					c.inner.style.transform = s <= 0.001 ? '' : `translateY(calc(${ ( s * 100 ).toFixed( 3 ) }% + ${ ( s * 24 ).toFixed( 2 ) }px))`;
				}
				if ( c.band && c.clip ) {
					const m = tb( n ) + c.i * E_;
					const y = easeInOut( clamp01( ( t - m ) / GD ) );
					const k = easeOut( clamp01( ( t - ( m + E_ ) ) / IB ) );
					if ( y <= 0 || k >= 1 ) {
						c.band.hidden = true;
					} else {
						c.band.hidden = false;
						c.clip.style.clipPath = `inset(-4px calc(100% - ${ z( c, y ) }) -4px ${ z( c, k ) })`;
					}
				}
			} );
		};
		const frame = ( now ) => {
			raf = 0;
			if ( ! t0 ) t0 = now;
			progress = Math.min( 1, ( now - t0 ) / DUR );
			paintCards();
			if ( progress < 1 ) raf = requestAnimationFrame( frame );
		};
		const reset = () => {
			if ( raf ) cancelAnimationFrame( raf );
			raf = 0; t0 = 0; progress = 0;
			paintCards();
		};
		const io = new IntersectionObserver( ( [ e ] ) => {
			if ( ! live ) return;
			if ( e.isIntersecting ) {
				if ( ! raf && progress < 1 ) { t0 = 0; raf = requestAnimationFrame( frame ); }
			} else {
				reset();
			}
		}, { threshold: 0.25 } );
		const onScroll = () => { if ( live ) paintArrow(); };
		const apply = () => {
			live = ! reduce.matches;
			root.classList.toggle( 'og--live', live );
			if ( ! live ) {
				io.disconnect();
				reset();
				cards.forEach( ( c ) => { if ( c.inner ) c.inner.style.transform = ''; if ( c.band ) c.band.hidden = true; } );
				if ( arrow ) arrow.style.removeProperty( '--og-arrow' );
				return;
			}
			prepareBands();
			paintArrow();
			progress = 0;
			paintCards();
			io.observe( list );
		};
		window.addEventListener( 'scroll', onScroll, { passive: true } );
		window.addEventListener( 'resize', () => { if ( live ) { prepareBands(); paintArrow(); paintCards(); } } );
		if ( document.fonts && document.fonts.ready ) document.fonts.ready.then( () => { if ( live ) prepareBands(); } );
		reduce.addEventListener( 'change', apply );
		apply();
	} );
} )();
